import Vue from 'vue'
import { OktaAuth } from '@okta/okta-auth-js'
import OktaVue, { LoginCallback } from '@okta/okta-vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'

//chart builder
import ChartBuilder from '../views/charts/ChartBuilder.vue'
import MyCharts from '../views/charts/MyCharts.vue'

//reports
import PostSevDetails from '../views/reports/PostSevDetails.vue'
import PostSevData from '../views/reports/PostSevData.vue'
import DailyStandup from '../views/reports/DailyStandup.vue'
import TimeBetweenFailures from '../views/reports/TimeBetweenFailures.vue'
import HighSevDetails from '../views/reports/HighSevDetails.vue'
import AlertStatDetails from '../views/reports/AlertStatDetails.vue'
import Report from '../views/reports/Report.vue'
import AutoRemovedHistory from '../views/reports/AutoRemovedHistory.vue'

//administrator
import ChartColumns from '../views/administrator/ChartColumns.vue'
import ReportBuilder from '../views/administrator/ReportBuilder.vue'
import Users from '../views/administrator/Users.vue'
import Operators from '../views/administrator/Operators.vue'
import SensitiveNameManagement from '../views/administrator/SensitiveNameManagement.vue'

//help
import Help from '../views/help/Help.vue'
import HelpGuides from '../views/administrator/HelpGuides.vue'
import HelpCaptions from '../views/administrator/HelpCaptions.vue'

//unauthorized
import Unauthorized from '../views/Unauthorized.vue'

//404 - Page Not Found
import PageNotFound from '../views/404.vue'

const CALLBACK_PATH = '/login/callback'

import config from '../../public/okta.config.json';

const oktaAuth = new OktaAuth(config.oidc)

oktaAuth.tokenManager.on('expired', () => {
    window.localStorage.clear();
    window.location.reload();
});

Vue.use(VueRouter)

const routes = [
    {
        path: CALLBACK_PATH,
        component: LoginCallback
    },
    {
        path: '/',
        name: 'Home',
        components: {
            header: Header,
            default: Home,
            footer: Footer
        },
        meta: { requiresAuth: true }
    },
    {
        path: '/unauthorized',
        name: 'Unauthorized',
        components: {
            default: Unauthorized,
        }
    },
    {
        path: '/chartBuilder/:type?/:id?/:action?',
        name: 'ChartBuilder',
        components: {
            header: Header,
            default: ChartBuilder,
            footer: Footer
        },
        props: true,
        meta: { title: 'Chart Builder', requiresAuth: true }
    },
    {
        path: '/mycharts',
        name: 'MyCharts',
        components: {
            header: Header,
            default: MyCharts,
            footer: Footer
        },
        meta: { title: 'My Charts', requiresAuth: true }
    },
    {
        path: '/AutoRemovedHistory',
        name: 'AutoRemovedHistory',
        components: {
            header: Header,
            default: AutoRemovedHistory,
            footer: Footer
        },
        meta: { title: 'Auto Removed History', requiresAuth: true }
    },
    {
        path: '/report/:name?',
        name: 'Report',
        components: {
            header: Header,
            default: Report,
            footer: Footer
        },
        props: true,
        meta: { title: `Report`, requiresAuth: true }
    },
    {
        path: '/highSevDetails/:id',
        name: 'HighSevDetails',
        components: {
            header: Header,
            default: HighSevDetails,
            footer: Footer
        },
        props: true,
        meta: { title: 'High Sev Details', requiresAuth: true }
    },
    {
        path: '/postsevdetails',
        name: 'PostSevDetails',
        components: {
            header: Header,
            default: PostSevDetails,
            footer: Footer
        },
        meta: { title: 'Post Sev Details', requiresAuth: true }
    },
    {
        path: '/postsevdata',
        name: 'PostSevData',
        components: {
            header: Header,
            default: PostSevData,
            footer: Footer
        },
        meta: { title: 'Post Sev Data', requiresAuth: true }
    },
    {
        path: '/alertStatDetails',
        name: 'AlertStatDetails',
        components: {
            header: Header,
            default: AlertStatDetails,
            footer: Footer
        },
        meta: { title: 'AlertStatDetails', requiresAuth: true }
    },
    {
        path: '/helpguides',
        name: 'HelpGuides',
        components: {
            header: Header,
            default: HelpGuides,
            footer: Footer
        },
        meta: { title: 'Help Guides', requiresAuth: true }
    },
    {
        path: '/helpCaptions',
        name: 'HelpCaptions',
        components: {
            header: Header,
            default: HelpCaptions,
            footer: Footer
        },
        meta: { title: 'Help Captions', requiresAuth: true }
    },
    {
        path: '/dailystandup',
        name: 'DailyStandup',
        components: {
            header: Header,
            default: DailyStandup,
            footer: Footer
        },
        meta: { title: 'Daily Standup', requiresAuth: true }
    },
    {
        path: '/chartColumns',
        name: 'ChartColumns',
        components: {
            header: Header,
            default: ChartColumns,
            footer: Footer
        },
        meta: { title: 'Chart Columns', requiresAuth: true }
    },
    {
        path: '/reportBuilder',
        name: 'ReportBuilder',
        components: {
            header: Header,
            default: ReportBuilder,
            footer: Footer
        },
        meta: { title: 'Report Builder', requiresAuth: true }
    },
    {
        path: '/users',
        name: 'Users',
        components: {
            header: Header,
            default: Users,
            footer: Footer
        },
        meta: { title: 'Users', requiresAuth: true }
    },
    {
        path: '/operators',
        name: 'Operators',
        components: {
            header: Header,
            default: Operators,
            footer: Footer
        },
        meta: { title: 'Operators', requiresAuth: true }
    },
    {
        path: '/sensitiveNameManagement',
        name: 'SensitiveNameManagement',
        components: {
            header: Header,
            default: SensitiveNameManagement,
            footer: Footer
        },
        meta: { title: 'Sensitive Name Management', requiresAuth: true }
    },
    {
        path: '/timebetweenfailures',
        name: 'TimeBetweenFailures',
        components: {
            header: Header,
            default: TimeBetweenFailures,
            footer: Footer
        },
        meta: { title: 'Time Between Failures', requiresAuth: true }
    },
    {
        path: '/help',
        name: 'Help',
        components: {
            header: Header,
            default: Help,
            footer: Footer
        },
        meta: { title: 'Help', requiresAuth: true }
    },
    //404
    {
        path: "*",
        component: PageNotFound,
        meta: { title: 'Page Not Found'}
    },
    //these below will support v1 backward compatibility
    {
        path: '/OutstandingPostSev',
        name: 'Report',
        redirect: "report/OutstandingPostSevs",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/SevImpact',
        name: 'Report',
        redirect: "report/SevImpactSignOff",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/ExecReport',
        name: 'Report',
        redirect: "report/ExecReport",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/RegReport',
        name: 'Report',
        redirect: "report/RegulationsReport",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/SportsBook/SportsHighSevs',
        name: 'Report',
        redirect: "report/SportsbookReport",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/Reports/MeanTimeReport',
        name: 'Report',
        redirect: "report/MeantimeReport",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/tools/PostSevs',
        name: 'Report',
        redirect: "/PostSevDetails",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/Reports/TimeBetweenFailures',
        name: 'Report',
        redirect: "/tools/DailyIssues",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/tools/DailyIssues',
        name: 'Report',
        redirect: "/dailystandup",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/tools/SuperGroup',
        name: 'Report',
        redirect: "/report/SuperGroup",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/StatsPage',
        name: 'Report',
        redirect: "/report/HighSevCountByOperator",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/Stats/PostSevStats',
        name: 'Report',
        redirect: "/report/PostSevStats",
        meta: { title: 'Report', requiresAuth: true }
    },
    {
        path: '/Stats/AlertStats',
        name: 'Report',
        redirect: "/report/AlertStats",
        meta: { title: 'Report', requiresAuth: true }
    },
    
]

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    if (to.path !== "/login/callback") {
        sessionStorage.setItem('url', to.path);
    }

    document.title = to.meta.title ? `${to.meta.title} - iNoc v2` : 'iNoc v2';

    if (to.path.includes('highSevDetails')) {
        document.title = `${to.params.id} - iNoc v2 - HighSevDetails`;
    }

    next();
});

Vue.use(OktaVue, { oktaAuth })

export default router
